import script from "./bgMusicList.vue?vue&type=script&setup=true&lang=js"
export * from "./bgMusicList.vue?vue&type=script&setup=true&lang=js"

import "./bgMusicList.vue?vue&type=style&index=0&id=5eda9d9a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eda9d9a"]])

export default __exports__